const MAP_ROOT = '/api/prospecting/map';
const CRM_ROOT = '/api/prospecting/crm';

function url(root, path, params = {}) {
  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.set(key, String(value));
  });
  const suffix = query.toString();
  return `${root}${path}${suffix ? `?${suffix}` : ''}`;
}

async function request(token, root, path, {
  params = {}, method = 'GET', body, formData, signal,
} = {}) {
  if (!token) throw new Error('Brak tokenu użytkownika ONE.');
  const headers = {
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  };
  let payload;
  if (formData) payload = formData;
  else if (body !== undefined) {
    headers['Content-Type'] = 'application/json';
    payload = JSON.stringify(body);
  }

  const response = await fetch(url(root, path, params), {
    method,
    headers,
    signal,
    body: payload,
  });

  let data = null;
  try { data = await response.json(); } catch (error) { data = null; }
  if (!response.ok) {
    const message = data?.message || data?.detail || data?.error || `Błąd API (${response.status}).`;
    const apiError = new Error(message);
    apiError.status = response.status;
    apiError.payload = data;
    throw apiError;
  }
  return data;
}

export function getPotentialMap(token, { product, scope, scopeId }, signal) {
  return request(token, MAP_ROOT, '/potential', {
    params: { product, scope, scopeId },
    signal,
  });
}
export function getMapGeometry(token, { level, parent, code }, signal) {
  return request(token, MAP_ROOT, '/geometry', { params: { level, parent, code }, signal });
}
export function searchMarket(token, { product, q, segments = [] }, signal) {
  return request(token, MAP_ROOT, '/search', {
    params: { product, q, segments: Array.isArray(segments) && segments.length ? segments.join(',') : '' },
    signal,
  });
}
export function getMarketEntity(token, { product, id }, signal) {
  return request(token, MAP_ROOT, `/entities/${encodeURIComponent(id)}`, { params: { product }, signal });
}
export function getMapDiagnostics(token, signal) {
  return request(token, MAP_ROOT, '/diagnostics', { signal });
}
export function refreshRspoMapLocations(token, {
  scopeId, product = 'kidplace', segments = [], includeMap = true,
}, signal) {
  return request(token, MAP_ROOT, '/locations/rspo/refresh', {
    params: {
      scopeId,
      product,
      segments: Array.isArray(segments) && segments.length ? segments.join(',') : '',
      includeMap: includeMap ? 1 : 0,
    },
    signal,
    method: 'POST',
  });
}
export function refreshSingleRspoMapLocation(token, registryId, signal) {
  return request(token, MAP_ROOT, `/locations/rspo/${encodeURIComponent(registryId)}/refresh`, { signal, method: 'POST' });
}
export function getCommuneMapContext(token, { scopeId }, signal) {
  return request(token, MAP_ROOT, '/context', { params: { scopeId }, signal });
}
export function refreshMarketEntityChildren(token, { product, id }, signal) {
  return request(token, MAP_ROOT, `/entities/${encodeURIComponent(id)}/refresh-children`, { params: { product }, signal, method: 'POST' });
}

export function getCrmOptions(token, { refresh = false } = {}, signal) {
  return request(token, CRM_ROOT, '/options', { params: { refresh: refresh ? 1 : 0 }, signal });
}
export function planCrmSync(token, body, signal) {
  return request(token, CRM_ROOT, '/plan', { method: 'POST', body, signal });
}
export function syncCrmTarget(token, body, signal) {
  return request(token, CRM_ROOT, '/sync', { method: 'POST', body, signal });
}
export function pullCrmEntity(token, { id, product }, signal) {
  return request(token, CRM_ROOT, `/entities/${encodeURIComponent(id)}/pull`, { params: { product }, method: 'POST', signal });
}
export function getCrmEntityState(token, { id, product }, signal) {
  return request(token, CRM_ROOT, `/entities/${encodeURIComponent(id)}/state`, { params: { product }, signal });
}
export function getCrmCompetitionCatalog(token, signal) {
  return request(token, CRM_ROOT, '/competition/catalog', { signal });
}
export function setCrmCompetition(token, body, signal) {
  return request(token, CRM_ROOT, '/competition', { method: 'POST', body, signal });
}
export function setCrmMarketStatus(token, body, signal) {
  return request(token, CRM_ROOT, '/market-status', { method: 'POST', body, signal });
}
export function importCompetitionCsv(token, file, { pushToPipedrive = false, recoverMissing = false } = {}, signal) {
  const form = new FormData();
  form.append('file', file);
  form.append('push_to_pipedrive', pushToPipedrive ? '1' : '0');
  form.append('recover_missing', recoverMissing ? '1' : '0');
  return request(token, CRM_ROOT, '/competition/import', { method: 'POST', formData: form, signal });
}
export function refreshCrmLabels(token, signal) {
  return request(token, CRM_ROOT, '/labels/refresh', { method: 'POST', signal });
}
export function getCrmOperation(token, id, signal) {
  return request(token, CRM_ROOT, `/operations/${encodeURIComponent(id)}`, { signal });
}

// Evidence review and on-demand contact enrichment (JWT from ONE AuthContext).
export function getEntitySourceLinks(token,id,signal) { return request(token,MAP_ROOT,`/entities/${encodeURIComponent(id)}/source-links`,{signal}); }
export function getEntityEvidence(token,id,signal) { return request(token,MAP_ROOT,`/entities/${encodeURIComponent(id)}/evidence`,{signal}); }
export function sendContactCandidateToPipedrive(token,id,evidenceId,signal) { return request(token,MAP_ROOT,`/entities/${encodeURIComponent(id)}/contacts/${encodeURIComponent(evidenceId)}/send-to-pipedrive`,{method:'POST',signal}); }
export function enrichEntityContacts(token,id,signal) { return request(token,MAP_ROOT,`/entities/${encodeURIComponent(id)}/enrich-contacts`,{method:'POST',signal}); }
export function getEntityDemo(token,id,signal) { return request(token,MAP_ROOT,`/entities/${encodeURIComponent(id)}/demo`,{signal}); }
export function createEntityDemo(token,id,signal) { return request(token,MAP_ROOT,`/entities/${encodeURIComponent(id)}/demo`,{method:'POST',signal}); }
export function deleteEntityDemo(token,id,signal) { return request(token,MAP_ROOT,`/entities/${encodeURIComponent(id)}/demo`,{method:'DELETE',params:{confirm:1},signal}); }
export function setEntityDemoPeriod(token,id,body,signal) { return request(token,MAP_ROOT,`/entities/${encodeURIComponent(id)}/demo/period`,{method:'PATCH',body,signal}); }


export function getSalesWorklist(token, filters = {}, signal) { return request(token, MAP_ROOT, '/worklist', { params: filters, signal }); }

export function getSalesWorklistDataset(token, signal) { return request(token, MAP_ROOT, '/worklist/dataset', { signal }); }

// MALUCH+ API: zachowanie funkcji v34.0.46+ przy integracji demo v34.0.51.
export function getMaluchEntitySource(token, id, signal) {
  return request(token, MAP_ROOT, `/maluch/entity/${encodeURIComponent(id)}`, { signal });
}
export function getMaluchOperatorFacilities(token, applicationId, signal) {
  return request(token, MAP_ROOT, `/maluch/application/${encodeURIComponent(applicationId)}/operator-facilities`, { signal });
}
export function confirmMaluchEmpatia(token, applicationId, empatiaEntityId) {
  return request(token, MAP_ROOT, '/maluch/confirm', { method: 'POST', body: { application_id: applicationId, empatia_entity_id: empatiaEntityId } });
}

export function rejectMaluchCandidate(token, applicationId) {
  return request(token, MAP_ROOT, '/maluch/reject', { method: 'POST', body: { application_id: applicationId } });
}

// MALUCH+ v34.0.43: review queue and verified investment evidence.
export function getMaluchReviewSummary(token, signal) {
  return request(token, MAP_ROOT, '/maluch/summary', { signal });
}
export function getMaluchReviewQueue(token, { status = 'candidate', before, limit = 30, teryt = '', ownership = 'all' } = {}, signal) {
  return request(token, MAP_ROOT, '/maluch/queue', { params: { status, before, limit, teryt, ownership }, signal });
}
export function getMaluchKpoRevisions(token, applicationId, signal) {
  return request(token, MAP_ROOT, `/maluch/revisions/${encodeURIComponent(applicationId)}`, { signal });
}
export function verifyMaluchStage(token, body) {
  return request(token, MAP_ROOT, '/maluch/stage', { method: 'POST', body });
}
